import type { PaginationUrlFilterNullableSingleType, PaginationUrlParametersSortType } from '@/services/tables/types'
import type { TicketSaveAsModalFormSchema } from '@/services/domain/tickets/modals/types'
import type { ApiColumn } from '@/core/tables/types'

export const enum TicketMessageAfterSubmitActions {
  STAY_ON_TICKET = 'stayOnTicket',
  GO_TO_ALL_TICKETS = 'goToAllTickets',
}

export interface TicketSaveDuplicateModalParams {
  title: string
  submitButtonTitle: string
  filters: PaginationUrlFilterNullableSingleType[]
  columns?: ApiColumn[]
  sorting?: null | PaginationUrlParametersSortType
  initFormData?: TicketSaveAsModalFormSchema
  afterSuccessSubmit: (id: string) => Promise<void>
}
